const CHARACTERS = {
    DRAW_RADIUS: 30,
    SPEED: 4,
    LIFES: 3,
    LIFE_POINTS: 100
}

export default CHARACTERS